import { render } from "./TeacherEdit.vue?vue&type=template&id=74e974d1&scoped=true&ts=true"
import script from "./TeacherEdit.vue?vue&type=script&lang=ts"
export * from "./TeacherEdit.vue?vue&type=script&lang=ts"

import "./TeacherEdit.vue?vue&type=style&index=0&id=74e974d1&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e974d1"]])

export default __exports__